import React from 'react';
import { InputGroup } from 'react-bootstrap';
import { Field } from 'formik';
import PropTypes from 'prop-types';

export const TotalSurface = ({ errors, touched, noTotal }) => (
  <div>
    <label>Superficie {!noTotal && 'total '}*</label>
    <InputGroup size="sm" className="formWidths" style={{ maxWidth: '150px' }}>
      <InputGroup.Text id="basic-addon1">m2</InputGroup.Text>
      <Field className="form-control" name="surface.totalSurface" />
    </InputGroup>
    {errors.surface?.totalSurface && touched.surface?.totalSurface && (
      <label className="w-100 text-danger mt-1">
        {errors.surface.totalSurface}
      </label>
    )}
  </div>
);

TotalSurface.propTypes = {
  errors: PropTypes.object,
  touched: PropTypes.object,
  noTotal: PropTypes.bool
};
